export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'read_only',
];

// View-only permission: when present it overrides the manage permissions above,
// hiding every action control in the UI (backend enforces it independently).
export const READ_ONLY_PERMISSION = 'read_only';

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// CMI: the "Unassigned" tab was removed from the default set. It can be brought
// back per-account by enabling the `unassigned_conversations_tab` feature flag;
// ChatList appends this entry to the tabs when that flag is on for the account.
export const UNASSIGNED_ASSIGNEE_TAB = {
  count: 'unAssignedCount',
  permissions: [
    ...ROLES,
    MANAGE_ALL_CONVERSATION_PERMISSIONS,
    CONVERSATION_UNASSIGNED_PERMISSIONS,
  ],
};

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  unread: {
    count: 'unreadCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
